import React from 'react';
import BookingButton from './BookingButton';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const PricingCard = ({ title, consultationPrice, removalPrice, isPopular }) => (
  <div className={`relative bg-white rounded-3xl p-8 shadow-xl border ${isPopular ? 'border-rose-gold ring-4 ring-rose-gold/10' : 'border-gray-100'} hover:shadow-2xl transition-all duration-300 flex flex-col h-full`}>
    {isPopular && (
      <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-rose-gold text-white px-4 py-1 rounded-full text-sm font-semibold shadow-md flex items-center gap-1">
        <SafeIcon icon={FiIcons.FiStar} className="fill-current" /> Popular Choice
      </div>
    )}
    <div className="mb-8 text-center">
      <h3 className="text-xl font-bold text-gray-800 mb-4">{title}</h3>
      <div className="space-y-4">
        <div className="bg-gray-50 rounded-2xl p-4 border border-gray-100">
          <p className="text-xs uppercase tracking-widest text-gray-500 font-bold mb-1">Consultation</p>
          <div className="flex justify-center items-baseline text-rose-gold">
            <span className="text-2xl font-semibold">£</span>
            <span className="text-4xl font-bold">{consultationPrice}</span>
          </div>
        </div>
        <div className="bg-rose-50/30 rounded-2xl p-4 border border-rose-100/50">
          <p className="text-xs uppercase tracking-widest text-rose-gold font-bold mb-1">Wax Removal</p>
          <div className="flex justify-center items-baseline text-gray-900">
            <span className="text-2xl font-semibold">£</span>
            <span className="text-4xl font-bold">{removalPrice}</span>
            <span className="text-gray-500 text-sm ml-1 font-medium">per ear</span>
          </div>
        </div>
      </div>
    </div>
    <ul className="space-y-4 mb-8 flex-grow">
      <li className="flex items-start gap-3">
        <div className="mt-1 bg-green-100 rounded-full p-1">
          <SafeIcon icon={FiIcons.FiCheck} className="text-green-600 text-xs" />
        </div>
        <span className="text-gray-600 text-sm">Professional ear examination</span>
      </li>
      <li className="flex items-start gap-3">
        <div className="mt-1 bg-green-100 rounded-full p-1">
          <SafeIcon icon={FiIcons.FiCheck} className="text-green-600 text-xs" />
        </div>
        <span className="text-gray-600 text-sm">Microsuction wax removal</span>
      </li>
      <li className="flex items-start gap-3">
        <div className="mt-1 bg-green-100 rounded-full p-1">
          <SafeIcon icon={FiIcons.FiCheck} className="text-green-600 text-xs" />
        </div>
        <span className="text-gray-600 text-sm">Video otoscopy included</span>
      </li>
      <li className="flex items-start gap-3">
        <div className="mt-1 bg-green-100 rounded-full p-1">
          <SafeIcon icon={FiIcons.FiCheck} className="text-green-600 text-xs" />
        </div>
        <span className="text-gray-600 text-sm">Expert aftercare advice</span>
      </li>
    </ul>
    <div className="mt-auto">
      <BookingButton text="Book Appointment" variant={isPopular ? "primary" : "outline"} className="w-full" />
    </div>
  </div>
);

const Pricing = () => {
  return (
    <section id="pricing" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-rose-gold font-semibold tracking-wider uppercase text-sm">Transparent Pricing</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2">Clear costs, exceptional care</h2>
          <p className="text-gray-500 mt-4 max-w-2xl mx-auto">
            Our pricing is split between a standard consultation and the treatment itself. You only pay for the removal if wax is found.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <PricingCard 
            title="In-Clinic Appointment" 
            consultationPrice="15" 
            removalPrice="20" 
            isPopular={true} 
          />
          <PricingCard 
            title="Home Visit" 
            consultationPrice="20" 
            removalPrice="20" 
            isPopular={false} 
          />
        </div>

        <div className="mt-12 max-w-2xl mx-auto bg-white p-6 rounded-2xl border border-gray-100 shadow-sm text-center">
          <p className="text-gray-600 text-sm">
            <span className="font-bold text-gray-900">Total Example (In-Clinic):</span> £35 for one ear or £55 for both ears (includes consultation).
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;